import { forwardRef } from "react";

import Select, { SelectProps } from "../Base/Select";
import HelperText from "../HelperText";
import Label from "../Label";

export interface SelectFieldProps extends Omit<SelectProps, "error"> {
  label: string;
  error?: boolean;
  errorMessage?: string;
  helperText?: string;
}

const SelectField = forwardRef<HTMLSelectElement, SelectFieldProps>(
  ({ label, error, errorMessage = null, helperText = null, ...props }, ref) => {
    return (
      <Label content={label}>
        <Select {...props} error={!!errorMessage || error} ref={ref} />
        <HelperText
          content={errorMessage || helperText || ""}
          error={!!errorMessage || error}
        />
      </Label>
    );
  }
);
SelectField.displayName = "SelectField";

export default SelectField;
